goog.provide("shadow.js.shim.module$$mui$material$Popper");
goog.provide("module$shadow_js_shim_module$$mui$material$Popper");
shadow.js.shim.module$$mui$material$Popper = shadow.js.nativeProvides["@mui/material/Popper"] = shadow$bridge("@mui/material/Popper");
module$shadow_js_shim_module$$mui$material$Popper.default = shadow.js.shim.module$$mui$material$Popper;
